module.exports = __webpack_public_path__ + "img/dsci0125.e85a024c.jpg";